<template>
  <div>
    <div class="row mt-5 container-fluid">
        <div class="col-sm-4">
            <div class="image-header">
                <strong class="ml-2"> Consulta #1 </strong>
            </div>   
            <div class="border border-success">
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/operador.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Asignado a: <strong>Luis García - Atención a clientes</strong></span></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/calendar.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Creada: <strong>15-09-2022</strong></span></div>    
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/faq.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Motivo: <strong>Prórroga...</strong></span></div>    
                </div>
                <div class="row mt-3 mb-2">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/process.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Estatus: <strong>Asignada a un operador</strong></span></div>    
                </div>               
            </div>
        </div>
        <div class="col-sm-4">
            <div class="image-header">
                <strong class="ml-2">Consulta #2</strong>
            </div>   
            <div class="border border-success">
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/operador.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Asignado a: <strong>Laura Borrás - Atención a clientes</strong></span></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/calendar.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Creada: <strong>15-09-2022</strong></span></div>    
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/faq.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Motivo: <strong>Carta saldo...</strong></span></div>    
                </div>
                <div class="row mt-3 mb-2">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/process.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Estatus: <strong>En proceso de resolución</strong></span></div>    
                </div>               
            </div>
        </div>
        <div class="col-sm-4">
            <div class="image-header">
                <strong class="ml-2">Consulta #3</strong>
            </div>   
            <div class="border border-success">
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/operador.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Asignado a: <strong>Yadira Azuceno - Atención a clientes</strong></span></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/calendar.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Creada: <strong>15-09-2022</strong></span></div>    
                </div>
                <div class="row mt-3">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/faq.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Motivo: <strong>Linea de crédito adicional...</strong></span></div>    
                </div>
                <div class="row mt-3 mb-2">
                    <div class="col-sm-2"><img class="ml-2 img-fluid" src="@/assets/img/process.png" alt="" width="100%" height="100%"></div>
                    <div class="col-sm-10 mt-1 font-card"> <span>Estatus: <strong>En proceso de resolución</strong></span></div>    
                </div>               
            </div>
        </div>
        <br>



    </div>

    
             
  </div>
</template>

<script>
import Historial from "./Historial";
export default {
    components:{
        Historial
    },
    data(){
        return{
            historial:false,
        }
    }
}
</script>

<style lang="scss" scoped>
.image-header{
    display: block;
    height: auto;
    background-image: url(https://servicios.bienparabien.com/img/fondos/GNOME-Fenestra600.jpg);
    color: white;
}
.font-card{
    font-size: 13px;
}
</style>